import { memo } from 'react'

interface WaveSVGProps {
  height?: number
  className?: string
  fill?: string
}

export const WaveSVG = memo(function WaveSVG({ height = 72, className = '', fill }: WaveSVGProps) {
  return (
    <div className={`leading-0 pointer-events-none absolute inset-x-0 bottom-0 ${className}`}>
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        aria-hidden="true"
        style={Object.assign({}, { display: 'block', width: '100%', height })}
      >
        <path
          d="M0,64L60,74.7C120,85,240,107,360,106.7C480,107,600,85,720,69.3C840,53,960,43,1080,48C1200,53,1320,75,1380,85.3L1440,96L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z"
          className={fill || 'fill-indigo-500/[0.12] dark:fill-indigo-400/[0.14]'}
        />
      </svg>
    </div>
  )
})
